import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'; //状态store
import Cookies from 'js-cookie';
//webpack热加载在开发环境下会很慢，因此只在生产环境下进行懒加载
// const _import = require('./_import_' + process.env.NODE_ENV);
// const Login = _import('login/login');
const Login = ()=> import('../views/login/login')
import Home from '../views/backStage/home'
import ClassInformation from "@/views/backStage/children/ClassInformation/ClassInformation" // 安全检查分类信息
import EntryInformation from "@/views/backStage/children/EntryInformation/EntryInformation" // 安全检查条目信息
import ChecklistTemp from "@/views/backStage/children/ChecklistTemp/ChecklistTemp" // 检查表模板
import ProjectTemp from "@/views/backStage/children/ProjectTemp/ProjectTemp" // 项目模板
import CheckObj from "@/views/backStage/children/CheckObj/CheckObj" // 检查对象类型
import Organlist from "@/views/backStage/children/Organlist/Organlist" // 机构列表
import PersonManage from "@/views/backStage/children/PersonManage/PersonManage" // 人员管理
import RoleManage from "@/views/backStage/children/RoleManage/RoleManage" // 角色管理
import Edit from "@/views/backStage/children/ChecklistTemp/edit/edit" // 检查表模板
// import HelloWorld from '@/views/HelloWorld'
// import menuList from '@/views/menuList'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    //登录、找回密码、重新设置密码、以及401、404
    { path: '/login', component: Login, hidden: true },
    //路由 /  重定向到首页
    {
      path: '/',
      //redirect: '/lbs/CarGps',  //路由为 / 就重定向到默认首页
      redirect: to => {
          // 方法接收 目标路由 作为参数  return 重定向的 字符串路径/路径对
          let paths = "";
          if (store.getters.routerPath && store.getters.routerPath) {
              paths = store.getters.routerPath;
          } else {
              paths = '/login';
          }
          return paths;
      },
      hidden: true,
  },   
    // { 
    //   path: '/',
    //   name:'Home',
    //   component: Home, 
    //   // hidden: true 
    //   redirect:'/baseData'
    // },
    {
      path: '/baseData', //基础数据维护
      name: 'Home',
      component: Home,
      meta:{title:'基础数据维护'},
      redirect:'/baseData/ClassInformation',
      children:[
        {
          path:"ClassInformation",
          name:"ClassInformation",
          component:ClassInformation,
          meta:{title:"安全检查分类信息"}
        },
        {
          path:"EntryInformation",
          name:"EntryInformation",
          component:EntryInformation,
          meta:{title:"安全检查条目信息"}
        },
        {
          path:"ChecklistTemp",
          name:"ChecklistTemp",
          component:ChecklistTemp,
          meta:{title:"检查表模板"},
        },
        {
          path:"ProjectTemp",
          name:"ProjectTemp",
          component:ProjectTemp,
          meta:{title:"项目模板"}
        },
        {
          path:"CheckObj",
          name:"CheckObj",
          component:CheckObj,
          meta:{title:"检查对象类型"}
        },
        {
          path:"Edit",
          name:"Edit",
          component:Edit,
          meta:{title:"检查表模板"}
        },
      ]
    }, 
    {
      path: '/combination', // 组织机构
      name: 'Home',
      component: Home,
      meta:{title:'组织结构'},
      redirect:'/combination/Organlist',
      children:[
        {
          path:"Organlist",
          name:"Organlist",
          component:Organlist,
          meta:{title:"机构列表"}
        },
        {
          path:"PersonManage",
          name:"PersonManage",
          component:PersonManage,
          meta:{title:"人员管理"}
        },
        // {
        //   path:"RoleManage",
        //   name:"RoleManage",
        //   component:RoleManage,
        //   meta:{title:"角色管理"}
        // }
      ]
    },
  ]
})

const whiteList = ['/login']

router.beforeEach(async(to, from, next) => {
  let token = Cookies.get("token")

  if (token && token.trim().length > 0) {
    next()
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js